/**
 *  RaceView
 *
 *  Created by Legman on 21/03/2017.
 *
 */

/**
 * @class
 * @extends PIXI.Container
 * @memberOf race
 */
export default class RaceView extends PIXI.Container {
    /**
     * @param {number} [segmentWidth=830]
     * @param {number} [segmentHeight=136]
     */
    constructor(segmentWidth = 830, segmentHeight = 136) {
        super();

        /**
         * @member {number}
         * @private
         * @default 830
         */
        this._segmentWidth = segmentWidth;

        /**
         * @member {number}
         * @private
         * @default 136
         */
        this._segmentHeight = segmentHeight;

        /**
         * @type {number}
         * @default 14
         */
        this.drawDistance = 14;
    }

    /**
     * @param {RaceEntity} entity
     */
    updateRoadEntity(entity) {
        if (!entity.renderToWorld) return;

        if (entity.zDepth > this.drawDistance) {
            entity.view.visible = false;
            return;
        }

        entity.view.x = entity.screenPosition.x;
        entity.view.y = entity.screenPosition.y;

        const inv = 1 / entity.zDepth;
        entity.view.scale.x = inv * entity.scale.x;
        entity.view.scale.y = inv * entity.scale.y;
        entity.view.visible = (entity.view.scale.x * (1 / entity.scale.x) > 0 && entity.view.scale.y * (1 / entity.scale.y)) > 0;

        const frac = (this.drawDistance - entity.zDepth) / (this.drawDistance * 0.05);
        entity.view.alpha = Math.max(0, Math.min(1, frac)) * entity.alpha;
    }

    /**
     * @param {RaceSegment} segment
     * @param {Point4} [heading]
     */
    updateRoadSegment(segment, heading) {
        if (segment.zDepth < 0.7 || segment.zDepth > this.drawDistance) {
            segment.view.visible = false;
            return;
        }

        if (heading) {
            const h = segment.getHeading();
            const dot = h.x * heading.x + h.y * heading.y + h.z * heading.z;
            if (dot < 0.1) {
                segment.view.visible = false;
                return;
            }
        }

        const quad = segment.getQuad();
        segment.view.x = quad.topLeft.x;
        segment.view.y = quad.topLeft.y;

        let sx = (quad.topRight.x - quad.topLeft.x) / this._segmentWidth;
        let sy = (quad.bottomLeft.y - quad.topLeft.y) / this._segmentHeight;

        segment.view.scale.x = sx * 2;
        segment.view.scale.y = sy * 2;

        let frac = (this.drawDistance - segment.zDepth) / (this.drawDistance * 0.05);
        segment.view.alpha = Math.max(0, Math.min(1, frac));
        segment.view.visible = true;

        let sxl = (quad.topLeft.x - quad.bottomLeft.x) / 200;
        let sxr = -(quad.topRight.x - quad.bottomRight.x) / 200;

        const inv = 1 / sx;
        sxl *= inv;
        sxr *= inv;

        if (segment.view.x + segment.view.texture.width * 0.5 * segment.view.scale.x > 0) {
            segment.view.left.scale.x = Math.max(0, sxl);
            segment.view.left.scale.y = sxl / Math.abs(sxl);

            segment.view.right.scale.x = Math.abs(sxr);
            segment.view.right.scale.y = sxr / Math.abs(sxr);
        } else if (segment.view.x + segment.view.texture.width * 0.5 * segment.view.scale.x < 0) {
            segment.view.left.scale.x = Math.abs(sxl);
            segment.view.left.scale.y = sxl / Math.abs(sxl);

            segment.view.right.scale.x = Math.max(0, sxr);
            segment.view.right.scale.y = sxr / Math.abs(sxr);
        }

        segment.view.grassLeft.x = segment.view.left.x;
        segment.view.grassRight.x = segment.view.right.x;

        frac = 1 - (this.drawDistance - segment.zDepth) / (this.drawDistance * 1.04);
        segment.view.grassLeft.scale.x = frac * 24;
        segment.view.grassRight.scale.x = frac * 24;
    }

    /**
     * @returns {number}
     */
    get segmentWidth() {
        return this._segmentWidth;
    }

    /**
     * @returns {number}
     */
    get segmentHeight() {
        return this._segmentHeight;
    }
}
